angular.module('invoice')
    .component('invoiceProjectBgt', {
        bindings: {
            projectId: '<'
        },
        templateUrl: 'app/invoice/invoice-project/bgt/bgt.html',
        controller: function (InvoiceService, InvoiceProjectBgt, InvoiceProjectBgtService, Principal, BgtGroupingService, modals, toastr){
            this.$onInit = () => {
                this.items = []
                this.allGroupsExpanded = true
                this.showCents = false
                this.canEditInvoiceProjectBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_WRITE', 'ROLE_ADMIN']);
            }

            this.$onChanges = () => {
                this.canEditInvoiceProjectBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_WRITE', 'ROLE_ADMIN'])
                this.loadRevisions()
            };

            this.loadRevisions = () => {
                return InvoiceProjectBgt.revisions({entityId: this.projectId}).$promise.then(revisions => {
                    this.revisions = revisions
                    this.hasDraft = revisions.some(revision => revision.status === 'DRAFT')
                    this.selectedRevision = this.canEditInvoiceProjectBgt ? revisions.find(revision => revision.status === 'DRAFT') : null
                    this.selectedRevision = this.selectedRevision || revisions.find(revision => revision.status === 'ACTIVE') || revisions[0] || null
                    return this.loadItems()
                })
            }
            this.loadItems = () => {
                const params = {entityId: this.projectId}
                if (this.selectedRevision) {
                    params.revisionId = this.selectedRevision.id
                }
                return InvoiceProjectBgt.query(params).$promise.then(result => {
                    this.items = result;
                    this.processGrouped();
                })
            }
            this.selectRevision = revision => {
                this.selectedRevision = revision
                return this.loadItems()
            }
            this.selectDraft = () => {
                const draft = this.revisions.find(revision => revision.status === 'DRAFT')
                if (draft) {
                    return this.selectRevision(draft)
                }
            }
            this.isRevisionSelected = revision => this.selectedRevision && revision.id === this.selectedRevision.id
            this.isDraftSelected = () => this.selectedRevision && this.selectedRevision.status === 'DRAFT'
            this.isInitialRevision = () => this.selectedRevision && this.selectedRevision.revisionNumber === 1
            this.isCommentRequired = () => !this.isInitialRevision()
            this.revisionStatusLabel = revision => ({DRAFT: 'Robocza', ACTIVE: 'Aktualna', ARCHIVED: 'Archiwalna'})[revision.status]
            this.createRevision = () => {
                if (this.creatingRevision) {
                    return
                }
                this.creatingRevision = true
                return InvoiceProjectBgt.createRevision({entityId: this.projectId}, {}).$promise
                    .then(() => this.loadRevisions())
                    .catch(() => toastr.error('Nie udało się utworzyć wersji roboczej BGT'))
                    .finally(() => this.creatingRevision = false)
            }
            this.publishRevision = () => {
                if (!this.isDraftSelected() || (this.isCommentRequired() && (!this.selectedRevision.comment || !this.selectedRevision.comment.trim()))) {
                    toastr.error('Opis wersji jest wymagany')
                    return
                }
                return modals.confirm('Czy zapisać wersję BGT <strong>' + this.selectedRevision.revisionNumber + '</strong> jako aktualną?', () => InvoiceProjectBgt.publishRevision({entityId: this.projectId, revisionId: this.selectedRevision.id}, {version: this.selectedRevision.version, comment: this.selectedRevision.comment || null}).$promise).then(() => this.loadRevisions())
            }
            this.discardRevision = () => modals.confirmDelete('wersję roboczą BGT', () => InvoiceProjectBgt.deleteRevision({entityId: this.projectId, revisionId: this.selectedRevision.id}).$promise).then(() => this.loadRevisions())

            this.add = () => {
                InvoiceProjectBgtService.add(this.projectId, this.selectedRevision.id, this.getTotalsByCurrency()).then(() => this.loadRevisions())
            }
            this.edit = (item) => {
                InvoiceProjectBgtService.edit(this.projectId, this.selectedRevision.id, item, this.getTotalsByCurrency(item)).then(() => this.loadRevisions())
            }
            this.delete = (item) => {
                InvoiceProjectBgtService.delete(this.projectId, this.selectedRevision.id, item).then(() => this.loadRevisions())
            }

            this.getTotalsByCurrency = (excludedItem) => {
                return BgtGroupingService.sumAmountsByCurrency(this.items.filter(item => item !== excludedItem));
            }
            this.processGrouped = () => {
                this.groupedItems = BgtGroupingService.groupItemsByParent(this.items);
                angular.forEach(this.groupedItems, grouped => {
                    grouped.expanded = true
                    grouped.totalsByCurrency = BgtGroupingService.sumAmountsByCurrency(grouped.children)
                });
                this.allGroupsExpanded = true
                this.totalsByCurrency = this.getTotalsByCurrency();
            };
            this.toggleGroup = grouped => {
                grouped.expanded = !grouped.expanded
                updateAllGroupsExpanded()
            }
            this.toggleAllGroups = () => {
                const expanded = !this.allGroupsExpanded
                angular.forEach(this.groupedItems, grouped => grouped.expanded = expanded)
                this.allGroupsExpanded = expanded
            }
            const updateAllGroupsExpanded = () => {
                let allExpanded = true
                angular.forEach(this.groupedItems, grouped => allExpanded = allExpanded && grouped.expanded)
                this.allGroupsExpanded = allExpanded
            }
        }
    })
